<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
// import HelloWorld from './components/HelloWorld.vue'
import Login from './components/Login.vue'
import Acceso from './components/Acceso.vue'
import Lobby from './components/Lobby.vue'
import Sala from './components/Sala.vue'
import Chat from './components/Chat.vue'
import Atencion from './components/Atencion.vue'



export default {
  name: 'app',
  components: {
    Login,
    Acceso,
    Lobby,
    Sala,
    Chat,
    Atencion,
  }
}
</script>

<style>


body {
  /* background-image: url("~/img/chat-pleca.png"); 
  background-repeat: no-repeat;
  background-attachment: fixed;
  background-position: bottom center;
  background-size: 100%; */
  height: 100vh;
  margin: 0;
  padding: 0px;

  width: 100%;
  
}


#footerImg{
  position:fixed;
   bottom:20px;
    left:50%;
}
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
   overflow-x: hidden !important;
 
display: flex;
  height: 100%;

}

#imagenes_header{
  width:80%;
 margin:0 auto 0 auto;
 height: 100px;

}
#logo_chat_nuevo{
  text-align: center;
}
#imagenes_chat{
  width:80%; margin:0 auto 0 auto;
  height: 70px;
}

#chatComponent{
  /*background-color: #f0f0f0;
  border-radius: 25px;
    margin: 10px;
   height: 100%;*/
}

#FooterComponent{
  
  background-color: #8a8a8a;
   /* border-radius: 25px; */
}
</style>
